import { ENV } from "../utils";

export class Actividad {
  baseApi = ENV.BASE_API;

  async getActividadesByDocumento(accessToken, documentoId) {
    try {
      const url = `${this.baseApi}/actividades/documento/${documentoId}`;
      const params = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
